export default __webpack_public_path__ + "static/media/skills.b8d6277d.svg";